export default {"src":"/_next/static/media/sg.f06d7c5a.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};